// extracted by mini-css-extract-plugin
module.exports = {"container":"NxBreadcrumb__container--2lzXv1AcyLGr40ltXGYFOJ","item":"NxBreadcrumb__item--Y0dGLU1DQCjrAUFc4_PnG"};